import { configureStore, Middleware, Reducer } from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger'

export const create = (
  reducer: Reducer<any, any>,
  initialState = {},
  env = 'development',
  middleware: Middleware[] = [],
) => {
  const loggerMiddleware = (createLogger as any)({ collapsed: true })

  return configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => {
      // Actions carry service payloads (dates, files, entities with methods)
      // and state was never immutability-checked under redux-loop, so RTK's
      // dev-only checks would only add noise here.
      const base = getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }).prepend(...middleware)

      return env === 'development' ? base.concat(loggerMiddleware) : base
    },
  })
}
